/*
 * @Description: 
 * @Autor: lkz
 * @Date: 2021-05-24 18:09:40
 * @LastEditors: lkz
 * @LastEditTime: 2021-07-30 10:02:02
 */
/**
 * import中的webpackChunkName，为按需加载生成的JS名称，请使用 [project-name]-[module-name]，示例如下
 */
export default [
  {
    path: '/work',
    name: '/work',
    meta: {
      title: '',
      isYiXian: true
    },
    component: () => import (/* webpackChunkName: "example-example-configuration-center" */ '../views/work/work.vue')
  },
  {
    path: '/addbuchang',
    name: '/addbuchang',
    meta: {
      title: '新增补偿'
    },
    component: () => import (/* webpackChunkName: "example-example-configuration-center" */ '../views/work/components/right/addbuchang.vue')
  },
  {
    path: '/addAfterOrder',
    name: '/addAfterOrder',
    meta: {
      title: '新增售后'
    },
    component: () => import (/* webpackChunkName: "example-example-configuration-center" */ '../views/work/components/addAfterOrder/addAfter.vue')
  },
  {
    path: '/addSendSms',
    name: '/addSendSms',
    meta: {
      title: '发送短信'
    },
    component: () => import (/* webpackChunkName: "example-example-configuration-center" */ '../views/work/components/addSendSms/addSendSmsDialog.vue')
  },
  {
    path: '/xySendSms',
    name: '/xySendSms',
    meta: {
      title: '发送短信'
    },
    component: () => import (/* webpackChunkName: "example-example-configuration-center" */ '../views/work/components/addSendSms/xySendSms.vue')
  }
]
